<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="编辑"
      width="960px"
      :append-to-body="true"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <el-row type="flex" justify="space-between">
        <div>文件名：{{rowData.fileName}}</div>
        <el-button type="primary" size="small" @click="addVisible = true">添加spu</el-button>
      </el-row>
      <el-table
        :data="tableData"
        border
        :height="390"
        style="margin-top: 10px;"
      >
        <el-table-column label="SPU编码" prop="spuCode"></el-table-column>
        <el-table-column label="SPU名称" prop="spuName"></el-table-column>
        <el-table-column label="SPU品类" prop="spuCategory"></el-table-column>
        <el-table-column label="SPU进度" prop="spuTaskName"></el-table-column>
        <el-table-column label="更新说明" prop="instruction"></el-table-column>
        <el-table-column label="更新时间" prop="creationDate"></el-table-column>
        <el-table-column label="操作人" prop="createdBy"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="onRemove(scope.row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <add :visible.sync="addVisible" :data="data" :dataType="dataType" v-if="addVisible"></add>
    </q-dialog>
  </div>
</template>

<script>
import add from './add'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  components: { add },
  props: ['visible', 'data', 'dataType'],
  data() {
    return {
      tableData: [],
      addVisible: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
    rowData() {
      return this.data;
    }
  },
  mounted() {
    this.tableData = this.rowData.spuInfo;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      if (this.isNeedRefresh) {
        this.$emit('success');
      }
      this.$emit('close');
    },
    confirm() {
      this.updateVal();
    },
    onRemove(row) {
      let data = {
        fileId: row.fileId,
        productDataType: this.dataType,
        spuIds:[{instruction:row.instruction,spuId:row.dataId}] /*this.rowData.spuInfo.map(item=>{
          return {
            instruction:item.instruction,
            spuId:item.dataId
          }
        })*/
      }
      this.$q.newProduct.delSpuBom({data:data})
      .then(res=>{
        if(res.code == 200) {
          this.$message.success('移除成功')
          this.tableData = this.tableData.filter(v=>v.dataId !== row.dataId);
        }else{
          this.$message.error(res.message)
        }
      })
      .finally(_=>{
        this.$emit('onRemove', this.tableData);
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
